<template>
    <div>
        <el-row :gutter="20" class="row-list">
            <el-col :span="6">Price(HKD)</el-col>
            <el-col :span="14">
                <el-input-number v-model="form.price"  :min="0"  label=""></el-input-number>
            </el-col>
        </el-row>
        <el-row :gutter="20">
            <el-col :span="6">Payment template content</el-col>
            <el-col :span="14">
                <tinymceVue v-if="dialogVisible" :value-key="daa" v-model="form.paymentTemplateContent"></tinymceVue>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    import tinymceVue from '@/components/tinymceVue'
    export default {
        components:{tinymceVue},
        data() {
            return {
               dialogVisible: false,
            }
        },
        computed:{
            daa(){
                 return new Date() + ((Math.random() * 1000).toFixed(0) + '')
                    
            },
        },
         props:{
            form:{
                type:Object,
                default:function(){}
            }
        },
        watch:{
            form:{
                handler(newVal){
                    if(newVal)
                    this.dialogVisible = true
                },
                deep:true,
                immediate:true
              }
        },
    }
</script>

<style lang="scss" scoped>
.row-list{
    margin-bottom: 10px;
}
</style>